import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { System } from '../System';
import { Observable } from 'rxjs';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';

@Injectable()
export class CourseSectionSearchService {

  constructor(
    private http: HttpClient
  ) {}

  getClassSearch(schoolId: number, yearId: number, activeToday: boolean, courseName: string, courseNumber: string, sectionName: string, teacherName: string, room: string, classMeets: string, schoolIds: number[]): Observable<ClassroomSummary[]> {
    const queryString = '?schoolId=' + schoolId +
        '&yearId=' + yearId +
        '&activeToday=' + activeToday +
        '&courseName=' + courseName +
        '&courseNumber=' + courseNumber +
        '&sectionName=' + sectionName +
        '&teacherName=' + teacherName +
        '&room=' + room +
        '&classMeets=' + classMeets;
    return this.http.post<ClassroomSummary[]>(System.apiURL.Student + 'GetClassSearch' + queryString, schoolIds);
  }
}
